<!-- =========================================================================================
  File Name: base.vue
  Description: Setting Base
========================================================================================== -->

<template>
  <div id="setting-base">
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full mb-base" v-for="(item, index) in groups" :key="index">
      	<vx-card :title="item">
      		<div class="vx-row mb-6" v-for="(item2, index2) in setting[index]" :key="index2">
      			<div class="vx-col sm:w-1/2 w-full">
      				<div>{{item2.title}}</div>
      		    <small class="text-grey">{{item2.remark}}</small>
      			</div>
      			<div class="vx-col sm:w-1/2 w-full">
      				<vs-input class="w-full" v-if="item2.component === 'input'" v-model="setting[index][index2].value" />
              <vs-switch v-if="item2.component === 'switch'" v-model="setting[index][index2].value" />
              <vs-select class="w-full" v-if="item2.component === 'select'" v-model="setting[index][index2].value">
                <vs-select-item :value="index3" :text="item3" v-for="(item3, index3) in item2.componentParam" :key="index3" />
              </vs-select>
      			</div>
      		</div>
      		<div class="vx-row">
      			<div class="vx-col sm:w-1/2 w-full ml-auto">
      				<vs-button class="mr-3 mb-2" @click="submit" :data-group="index">提交</vs-button>
      				<vs-button color="warning" type="border" class="mb-2" @click="reset" :data-group="index">重置</vs-button>
      			</div>
      		</div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      groups: [],
      setting: {},
      resetSetting: {}
    }
  },
  methods: {
    submit (e) {
      const group = e.currentTarget.dataset.group
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.data = this.setting[group]
      postdata.data = JSON.stringify(postdata.data)
      this.$utils.post('setting-baseDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
      })
    },
    reset (e) {
      const group = e.currentTarget.dataset.group
      this.setting[group] = JSON.parse(JSON.stringify(this.resetSetting[group]))
    }
  },
  mounted () {
    // 读取设置
    this.$utils.post('setting-base', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.groups = res.group
      const setting = {}
      let s
      for (let i = 0; i < res.setting.length; i++) {
        s = res.setting[i]
        s.componentParam = JSON.parse(s.componentParam)
        if (s.component === 'switch') s.value = s.value == 1
        if (!setting[res.setting[i].groupby]) setting[res.setting[i].groupby] = []
        setting[res.setting[i].groupby].push(res.setting[i])
      }
      this.setting = setting
      this.resetSetting = JSON.parse(JSON.stringify(setting))
    })
  }
}
</script>
